module.exports = __webpack_public_path__ + "img/caseBuilder-softwareEngineer.8a4ee0d5.webp";